import { render, staticRenderFns } from "./AdminEmailBlastGeneral.vue?vue&type=template&id=9781127c"
import script from "./AdminEmailBlastGeneral.vue?vue&type=script&lang=js"
export * from "./AdminEmailBlastGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports